
import { LS_ACADEMIC_YEAR_ID, LS_BRANCHID, LS_I18NEXT_LANG, LS_TOKEN } from "@/shared/constants";
import axios from "axios";

export const setupInterceptors = (api: ReturnType<typeof axios.create>) => {
  // Request Interceptor
  api.interceptors.request.use(
    (config: any) => {
      const token = localStorage.getItem(LS_TOKEN);
      const branchId = localStorage.getItem(LS_BRANCHID);
      const language = localStorage.getItem(LS_I18NEXT_LANG);
      const currentAcademicYear = localStorage.getItem(LS_ACADEMIC_YEAR_ID);

      config.headers["Authorization"] = `Bearer ${token}`;
      config.headers["Organization"] = "test";
      config.headers["Branch"] = `${branchId}`;
      config.headers["language"] = `${language}`;

      // OPT:
      config.headers["Accept-Encoding"] = "gzip, deflate, br";

      config.headers["academicYearId"] = currentAcademicYear;
      return config;
    },
    (error) => Promise.reject(error),
  );

  // Response Interceptor
  api.interceptors.response.use(
    (response) => response.data,
    (err) => {
      if (err?.message === "Network Error") {
        return Promise.reject(null);
      }
      return Promise.reject(err.response?.data);
    },
  );
};
